import React, { Fragment } from 'react';
import { Modal, Form, Input, InputNumber, Select } from 'antd';
import { Currency, valuesCategory } from '../../../../../utills/utils';

const FeeModal = ({
  visible,
  onCancel,
  onOk,
  initialValues,
  categoryGroup,
  feeForm
}) => {
  Form.useWatch([], feeForm);

  const hasErrors = feeForm
    .getFieldsError()
    .some(({ errors }) => errors.length > 0);

  const hasEmptyRequiredFields =
    !initialValues && !feeForm.isFieldsTouched(true);

  return (
    <Fragment>
      <Modal
        title={initialValues ? "Editar Taxa" : "Adicionar Taxa"}
        open={visible}
        onCancel={onCancel}
        onOk={() => feeForm.submit()}
        okText={initialValues ? "Salvar" : "Adicionar"}
        destroyOnClose
        okButtonProps={{
          disabled: hasErrors || hasEmptyRequiredFields,
        }}
      >
        <Form
          form={feeForm}
          layout="vertical"
          initialValues={initialValues ? {
            ...initialValues,
            name: initialValues.name || initialValues?.fee.displayName,
            currency: initialValues?.fee.currency || 'USD',
            value: initialValues?.fee.value || 0,
            group: initialValues.category || initialValues.group
          } : undefined}
          onFinish={onOk}
          preserve={false}
        >
          <Form.Item
            name="name"
            label="Nome da Taxa"
            rules={[{ required: true, message: 'Informe o nome da taxa' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="group"
            label="Categoria"
            initialValue={categoryGroup}
            rules={[{ required: true, message: 'Informe a categoria' }]}
          >
            <Select>
              {valuesCategory.map(category => (
                <Select.Option key={category} value={category}>
                  {category}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="currency"
            label="Moeda"
            rules={[{ required: true, message: 'Informe a moeda' }]}
          >
            <Select>
              {Object.values(Currency).map(currency => (
                <Select.Option key={currency} value={currency}>
                  {currency}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="value"
            label="Valor"
            rules={[{ required: true, message: 'Informe o valor' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              controls={false}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default FeeModal;
